import { classNames } from '@/util/tailwindHelpers'
import { ComponentPropsWithoutRef, ReactNode } from 'react'

interface Props extends ComponentPropsWithoutRef<'div'> {
  contentClassName?: string
  showBottomGradient?: boolean
  renderFooter?: ReactNode
}

export default function ControlsIsland({
  children,
  className,
  contentClassName,
  showBottomGradient = true,
  renderFooter
}: Props) {
  return (
    <div className={classNames('sticky z-30 top-[100dvh] h-0')}>
      <div
        className={classNames(
          'absolute left-0 right-0 bottom-0 px-1 sm:px-2 py-[18px] pointer-events-none',
          className
        )}
      >
        <div className={classNames(contentClassName, 'pointer-events-auto')}>
          {children}
        </div>

        {/* background lindear gradient */}
        {showBottomGradient && (
          <div className="absolute -z-[1] inset-0 bg-gradient-to-b from-gray-900/0 to-gray-900" />
        )}
        {renderFooter && (
          <div className="pointer-events-auto">{renderFooter}</div>
        )}
      </div>
    </div>
  )
}

export const ControlsIslandActionsWrapperSmall = ({
  children,
  className
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <ControlsIsland
      className={classNames('flex justify-center items-center', className)}
      contentClassName="rounded-[38px] p-[12px] bg-black/75 flex gap-[12px]"
    >
      {children}
    </ControlsIsland>
  )
}
